import React from 'react';
import PropTypes from 'prop-types';
import NewFiltersCheckbox from './NewFiltersCheckbox';

function NewFiltersCheckboxList({ filters,
    selectedFilters,
    keyToCheck,
    removeFromFilters,
    addToFilters }) {
    const listItems = filters.map((filter, filterIndex) => {
        const isSelected = (selectedFilters[keyToCheck] && selectedFilters[keyToCheck].indexOf(filter.value) > -1)
        return <NewFiltersCheckbox filter={filter}
            key={`filter-${filterIndex}`}
            keyToCheck={keyToCheck}
            isSelected={isSelected}
            value={filter.value}
            handleChange={isSelected ? removeFromFilters : addToFilters} />
    })
    return <ul className="filter-list__container">{listItems}</ul>
}

NewFiltersCheckboxList.propTypes = {
    filters: PropTypes.array
}

export default NewFiltersCheckboxList;